import MuiBox, { BoxProps as MUIBoxProps } from "@mui/material/Box";
import React from "react";
import { withDisplayName } from "../../utils/displayName";

export type BoxProps<D extends React.ElementType<any> = "div", P = {}> = {
  flex?: boolean;
} & MUIBoxProps<D, P>;

const Box = (
  { flex, ...props }: BoxProps<React.ElementType>,
  ref: React.Ref<any>,
) => <MuiBox ref={ref} {...props} {...(flex ? { display: "flex" } : {})} />;

const BoxWithRef = React.forwardRef(Box);
withDisplayName(BoxWithRef, "Box");
export default BoxWithRef;
